import type { CustomerUserError } from '$gql/storefront/schemas';

export const CUSTOMER_USER_ERROR_CAUSE = 'customerUserError' as const;

export type ParsedCustomerUserError = (AggregateError & { errors: Error[] }) | undefined;

export const handleCustomerUserErrors = (
  customerUserErrors: CustomerUserError[]
): ParsedCustomerUserError => {
  const errors: Error[] = [];

  customerUserErrors.forEach((error) =>
    errors.push(new Error(error.message, { cause: CUSTOMER_USER_ERROR_CAUSE }))
  );

  if (errors.length) {
    return new AggregateError(errors, undefined, { cause: CUSTOMER_USER_ERROR_CAUSE });
  }
};
